// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__xx4Io","content":"styles_content__1MZBd","checkbox":"styles_checkbox__3NkVx","checkboxLabel":"styles_checkboxLabel__1Dwyq"};